<div class="container">
    <section class="inner-container">
<div class="products" style="background: white; ">
  <div class="content-container">
    <div class="text-center">
      <h1 class="title-default intro-title">POS / mPOS </h1>
      <hr class="yellow-line-large">
      <p class="text-intro"></p>


    </div>
    <div class="inner">
      <div class="flex-wrap scroll_checklist">
            <form name="offer-letter-form" id="offer-letter-form" data-k2-validation="true" novalidate class="col-sm-8 general-form" style="padding: 0" (ngSubmit)="submit(true)">
              <!-- <p class="text-intro">Status: {{checklistStatuses[currentStatus()]}} <img *ngIf="currentStatus() == 0" class="" src="images/circular-tick.png" alt="Status"></p> -->
              
               

                <!-- <div *ngIf="!isMobile && src" class="boxx uP">
                  <object class="embed-responsive-item" width="100%" height="800" [data]="src" type="application/pdf">
                    
                        
                    
                  </object>
                  
                </div> -->

                <!-- <pdf-viewer  [src]="mobileSrc" [original-size]="false" [autoresize]="true" style="display: block;">
                  
                </pdf-viewer> -->

                <div class="row">
                  <div class="col-md-12" [hidden]="!isPublicOrPrivate">
                    <h3 class="vmid"> Congratulation! Your application for POS/mPOS  is approved. You may download Letter of Offer, Letter of Guarantee* and payment slip for fees indicated in the Letter of Offer (if any).<br/> 

                    </h3>
                  </div>

                  <div class="col-md-12" [hidden]="isPublicOrPrivate">
                    <h3 class="vmid"> Congratulation! Your application for POS/mPOS  is approved. You may download Letter of Offer and payment slip for fees indicated in the Letter of Offer (if any).<br/> 

                    </h3>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-4">
                  
                  </div>
                  <div class="col-md-4">
                    <button type="button" class="btn btn-primary btn-block center" (click)="downloadFile()">Download</button>
                    <a #oldownload [href]="mobileSrc"  download hidden></a>
                  </div>         
                  <div class="col-md-4">
                    
                  </div>   
                </div>   

                <div class="row">
                  <div class="col-md-12" [hidden]="!isPublicOrPrivate">
                      <h3 class="vmid">
                      If you accept the Letter of Offer, do print the Letter of Offer and Letter of Guarantee*, sign, scan as PDF format and upload below.<br/> 

                      </h3>
                  </div>
                  <div class="col-md-12" [hidden]="isPublicOrPrivate">
                      <h3 class="vmid">
                      If you accept the Letter of Offer, do print the Letter of Offer, sign, scan as PDF format and upload below.<br/> 

                      </h3>
                  </div>
                </div>


                <div class="row">
                  <div class="col-md-8">
                      <h5 class="vmid"> Do you accept the Letter of Offer?* </h5>
                      
                          <div class="col-md-12" [hidden]="valid || acceptance.value != undefined">
                              <label class="red">Please choose an option above</label>
                          </div>
                      
                  </div>
                  <div class="col-md-2">
                      <div class="custom-radio">                            
                          <label for="offer_letter_y"><input type="radio" id="offer_letter_y" [value]="true" name="acceptance" value="true" [ngModel]="detail?.acceptance" (ngModelChange)="detail.acceptance=$event" #acceptance="ngModel" [disabled]="loSubTags?.length > 0"  required/>
                              <span>
                                  Yes
                              </span>
                          </label>
                      </div>
                  </div>
                  <div class="col-md-2">
                      <div class="custom-radio">                            
                          <label for="offer_letter_n"><input type="radio" id="offer_letter_n" [value]="false" name="acceptance" value="false" [ngModel]="detail?.acceptance" (ngModelChange)="detail.acceptance=$event" #acceptance="ngModel" [disabled]="loSubTags?.length > 0" required/>
                              <span>
                                  No
                              </span>
                          </label>
                      </div>
                  </div>



                 
                

                  

                </div>

                <div class="row">
                   <div class="col-md-12" [hidden]="acceptance.value == undefined|| acceptance.value">
                      <h5> Please state the reason:* </h5>
                      <div class="row">
                          <div class="col-md-12">
                              <textarea rows="5" class="sampleData" name="reason" [ngModel]="detail?.reason" (ngModelChange)="detail.reason=$event" #reason="ngModel" placeholder="" trim="blur" [disabled]="loSubTags?.length > 0"></textarea>
                          </div>
                          <div class="col-md-12" [hidden]="valid || (reason.value != undefined && reason.value != '' )">
                              <label class="red">Please fill in the reason.</label>
                          </div>
                      </div>
                  </div>

                  <div class="col-md-6 mrgn-btm-1rem" [hidden]="acceptance.value == undefined|| !acceptance.value">
                    <h5>
                      Upload the signed Letter of Offer*
                    </h5>
                    <div *ngIf="uploader?.queue.length > 0 && uploader?.progress != 100">
                      <img class="loading-icon" src="../images/loading.gif" alt="image" *ngIf="uploader?.queue.length > 0 && uploader?.progress != 100"/>
                      Upload Progress: {{uploader?.queue.length > 0 ? uploader?.progress : 0}}%

                    </div>


                      
                      <!-- <div class="progress">
                          <div class="progress-bar progress-bar-success" role="progressbar" [ngStyle]="{ 'width': (uploader.queue[0] ? uploader.queue[0].progress : 0) + '%' }">
                            <span style="opacity: 0">...</span>
                          </div>
                      </div><br> -->
                    
                      <div class="boxx" style="padding: 5px 5px 5px 5px" [hidden]="cardsPosSignedLoPayeeAttachedFileExists">
                        <input (change)="addDoc('cards_pos_signed_lo_payee_attached', $event, false, submissionId)" type="file" accept=".pdf, application/pdf" name="signedLo" #signedLo/>
                      </div>
                    

                    <div class="boxx" style="padding: 5px 5px 5px 5px" [hidden]="!cardsPosSignedLoPayeeAttachedFileExists">
                      <p> Upload Successfully</p> 
                      <a [href]="getFileUrl(posSignedLoPayeeAttachedFileName)" download class="link" title="Download">Download</a> &nbsp; &emsp;
                      <a *ngIf="loSubTags?.length == 0" (click)="cardsPosSignedLoPayeeAttachedFileExists = false; signedLo.value = '';deleteDoc('cards_pos_signed_lo_payee_attached')" class="link">Delete</a>
                    </div>

                    <div *ngIf="!valid && !cardsPosSignedLoPayeeAttachedFileExists" class="red error">
                      Signed Letter of Offer required
                    </div>
                  </div>

                  <div class="col-md-6 mrgn-btm-1rem" [hidden]="!isPublicOrPrivate ||( acceptance.value == undefined|| !acceptance.value)">
                    <h5>
                      Upload the signed Letter of Guarantee*
                    </h5>
                    <div *ngIf="uploader?.queue.length > 0 && uploader?.progress != 100">
                      <img class="loading-icon" src="../images/loading.gif" alt="image" *ngIf="uploader?.queue.length > 0 && uploader?.progress != 100"/>
                      Upload Progress: {{uploader?.queue.length > 0 ? uploader?.progress : 0}}%

                    </div>


                      
                      <!-- <div class="progress">
                          <div class="progress-bar progress-bar-success" role="progressbar" [ngStyle]="{ 'width': (uploader.queue[0] ? uploader.queue[0].progress : 0) + '%' }">
                            <span style="opacity: 0">...</span>
                          </div>
                      </div><br> -->
                    
                      <div class="boxx" style="padding: 5px 5px 5px 5px" [hidden]="cardsPosSignedLgPayeeAttachedFileExists">
                        <input (change)="addDoc('cards_pos_signed_lg_payee_attached', $event, false, submissionId)" type="file" accept=".pdf, application/pdf" name="signedLg" #signedLg/>
                      </div>
                    

                    <div class="boxx" style="padding: 5px 5px 5px 5px" [hidden]="!cardsPosSignedLgPayeeAttachedFileExists">
                      <p> Upload Successfully</p> 
                      <a [href]="getFileUrl(posSignedLgPayeeAttachedFileName)" download class="link" title="Download">Download</a> &nbsp; &emsp;
                      <a *ngIf="loSubTags?.length == 0" (click)="cardsPosSignedLgPayeeAttachedFileExists = false; signedLg.value = ''; deleteDoc('cards_pos_signed_lg_payee_attached')" class="link">Delete</a>
                    </div>

                    <div *ngIf="!valid && !cardsPosSignedLgPayeeAttachedFileExists" class="red error">
                      Signed Letter of Guarantee required
                    </div>
                  </div>

                  <div class="col-md-12 mrgn-btm-1rem" [hidden]="acceptance.value == undefined|| !acceptance.value">
                    <h5>
                      Upload the payment slip for fees indicated in the Letter of Offer (if any)
                    </h5>
                    <div *ngIf="uploader?.queue.length > 0 && uploader?.progress != 100">
                      <img class="loading-icon" src="../images/loading.gif" alt="image" *ngIf="uploader?.queue.length > 0 && uploader?.progress != 100"/>
                      Upload Progress: {{uploader?.queue.length > 0 ? uploader?.progress : 0}}%

                    </div>


                      
                      <!-- <div class="progress">
                          <div class="progress-bar progress-bar-success" role="progressbar" [ngStyle]="{ 'width': (uploader.queue[0] ? uploader.queue[0].progress : 0) + '%' }">
                            <span style="opacity: 0">...</span>
                          </div>
                      </div><br> -->
                    
                      <div class="boxx" style="padding: 5px 5px 5px 5px" [hidden]="cardsPosSignedPaymentSlipPayeeAttachedFileExists || loSubTags?.length > 0">
                        <input (change)="addDoc('cards_pos_signed_payment_slip_payee_attached', $event, false, submissionId)" type="file" accept=".pdf, application/pdf" name="signedPaymentSlip" #signedPaymentSlip/>
                      </div>

                      <div class="boxx" style="padding: 5px 5px 5px 5px" *ngIf="!cardsPosSignedPaymentSlipPayeeAttachedFileExists && loSubTags?.length > 0">
                        <p> No file uploaded</p> 
                      </div>
                    

                    <div class="boxx" style="padding: 5px 5px 5px 5px" [hidden]="!cardsPosSignedPaymentSlipPayeeAttachedFileExists">
                      <p> Upload Successfully</p> 
                      <a [href]="getFileUrl(posSignedPaymentSlipPayeeAttachedFileName)" download class="link" title="Download">Download</a> &nbsp; &emsp;
                      <a *ngIf="loSubTags?.length == 0" (click)="cardsPosSignedPaymentSlipPayeeAttachedFileExists = false; signedPaymentSlip.value = ''; deleteDoc('cards_pos_signed_payment_slip_payee_attached')" class="link">Delete</a>
                    </div>

                   
                  </div>
                  
                </div>




                
              <!-- <div [hidden]="!running.value">
                <h5 class="title-form">Support</h5>

                <div class="row">
                  <div class="col-md-8">
                    <h5 class="vmid">
                      Do you display clear customer service details on your website? (e.g. phone number or e-mail)*
                      <div class="red" style="font-size: 13px" *ngIf="!valid && customerService.value == undefined">
                        This field is required
                      </div>
                    </h5>
                  </div>
                  <div class="col-md-2">
                    <div class="custom-radio">
                      <label for="customerService_y">
                        <input type="radio" id="customerService_y" [value]="true" name="customerService" #customerService="ngModel" [(ngModel)]="details.customer_service" [required]="running.value"/>
                        <span>
                          Yes
                        </span>
                      </label>
                    </div>
                  </div>
                  <div class="col-md-2">
                    <div class="custom-radio">
                      <label for="customerService_n">
                        <input type="radio" id="customerService_n" [value]="false" name="customerService" #customerService="ngModel" [(ngModel)]="details.customer_service" [required]="running.value"/>
                        <span>
                          No
                        </span>
                      </label>
                    </div>
                  </div>
                </div>
                
                <div class="row">
                  <div class="col-md-8">
                    <h5 class="vmid">
                      Do you store customer profiles on your website for support purposes?*
                      <div class="red" style="font-size: 13px" *ngIf="!valid && customerProfile.value == undefined">
                        This field is required
                      </div>
                    </h5>
                  </div>
                  <div class="col-md-2">
                    <div class="custom-radio">
                      <label for="customerProfile_y">
                        <input type="radio" id="customerProfile_y" [value]="true" name="customerProfile" #customerProfile="ngModel" [(ngModel)]="details.customer_profile" [required]="running.value"/>
                        <span>
                          Yes
                        </span>
                      </label>
                    </div>
                  </div>
                  <div class="col-md-2">
                    <div class="custom-radio">
                      <label for="customerProfile_n">
                        <input type="radio" id="customerProfile_n" [value]="false" name="customerProfile" #customerProfile="ngModel" [(ngModel)]="details.customer_profile" [required]="running.value"/>
                        <span>
                          No
                        </span>
                      </label>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-8">
                    <h5 class="vmid">
                      Do you provide a shipping tracking reference number to your customer?*
                      <div class="red" style="font-size: 13px" *ngIf="!valid && tracking.value == undefined">
                        This field is required
                      </div>
                    </h5>
                  </div>
                  <div class="col-md-2">
                    <div class="custom-radio">
                      <label for="tracking_y">
                        <input type="radio" id="tracking_y" [value]="true" name="tracking" #tracking="ngModel" [(ngModel)]="details.tracking_reference" [required]="running.value"/>
                        <span>
                          Yes
                        </span>
                      </label>
                    </div>
                  </div>
                  <div class="col-md-2">
                    <div class="custom-radio">
                      <label for="tracking_n">
                        <input type="radio" id="tracking_n" [value]="false" name="tracking" #tracking="ngModel" [(ngModel)]="details.tracking_reference" [required]="running.value"/>
                        <span>
                          No
                        </span>
                      </label>
                    </div>
                  </div>
                </div>

              </div> -->
              <div class="row" [hidden]="!isPublicOrPrivate">
                <div class="col-md-12">
                    <h3 class="vmid red">
                    * Letter of Guarantee is applicable to Private Limited (Sdn Bhd) and Public Listed (Berhad) 

                    </h3>
                    
                    
                </div>
              </div>

            <div [hidden]="acceptance.value == undefined|| !acceptance.value">
              <h5 style="padding-bottom: 0.5em">Please select Debit Card Routing option:*</h5>

              <div class="row">
                <div class="col-md-6">
                  <div class="custom-radio">
                    <label for="opt_yes">
                      <input type="radio" id="opt_yes" [value]="true" name="optIn" [ngModel]="pos?.opt_in" #optIn="ngModel" required (ngModelChange)="pos.opt_in=$event" [disabled]="loSubTags?.length > 0"/>
                      <span>
                        Opt In: MyDebit (Paynet)
                      </span>
                    </label>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="custom-radio">
                    <label for="opt_no">
                      <input type="radio" id="opt_no" [value]="false" name="optIn" [ngModel]="pos?.opt_in" #optIn="ngModel" required (ngModelChange)="pos.opt_in=$event" [disabled]="loSubTags?.length > 0"/>
                      <span>
                        Opt Out: Visa/ Master
                      </span>
                    </label>
                  </div>
                  <label class="yellow">
                                This option may take extra 7 days of processing time
                            </label>
                </div>
                <div [hidden]="valid || optIn.value!=null">
                  <label class="red">This field is required.</label>
                </div>
              </div>
              
              <div class="row" *ngIf="optIn.value != null && !(optIn.value)">
                <div class="col-md-3">
                
                </div>
                <div class="col-md-6">
                  <button type="button" class="btn btn-primary btn-block center" (click)="downloadOptOutFile()">Download Declaration Form</button>
                  <a #optOutdownload [href]="optOutSrc" download="Merchants_OptOut_Form.pdf" hidden></a>
                </div>         
                <div class="col-md-3">
                  
                </div>   
              </div> 

              <div class="row">
                <div class="col-md-12" *ngIf="optIn.value != null && !(optIn.value)">
                    <h3 class="vmid">
                    Please download and print the declaration form. Get it sign, scan as PDF format and upload below.<br/> 

                    </h3>
                </div>
              </div>

              <div class="row" *ngIf="optIn.value != null && !(optIn.value)">
                <div class="col-md-6 mrgn-btm-1rem">
                  <h5>
                    Upload the Signed Declaration Form
                  </h5>
                  <div *ngIf="uploader?.queue.length > 0 && uploader?.progress != 100">
                    <img class="loading-icon" src="../images/loading.gif" alt="image" *ngIf="uploader?.queue.length > 0 && uploader?.progress != 100"/>
                    Upload Progress: {{uploader?.queue.length > 0 ? uploader?.progress : 0}}%

                  </div>


                    
                    <!-- <div class="progress">
                        <div class="progress-bar progress-bar-success" role="progressbar" [ngStyle]="{ 'width': (uploader.queue[0] ? uploader.queue[0].progress : 0) + '%' }">
                          <span style="opacity: 0">...</span>
                        </div>
                    </div><br> -->
                  
                    <div class="boxx" style="padding: 5px 5px 5px 5px" [hidden]="cardsPosSignedDeclarationFormPayeeAttachedFileExists">
                      <input (change)="addDoc('cards_pos_signed_opt_out_declaration_form_payee_attached', $event, false, submissionId)" type="file" accept=".pdf, application/pdf" name="signedDf" #signedDf/>
                    </div>
                  

                  <div class="boxx" style="padding: 5px 5px 5px 5px" [hidden]="!cardsPosSignedDeclarationFormPayeeAttachedFileExists">
                    <p> Upload Successfully</p> 
                    <a [href]="getFileUrl(posSignedDeclarationFormPayeeAttachedFileName)" download class="link" title="Download">Download</a> &nbsp; &emsp;
                    <a *ngIf="loSubTags?.length == 0" (click)="cardsPosSignedDeclarationFormPayeeAttachedFileExists = false; signedDf.value = ''; deleteDoc('cards_pos_signed_opt_out_declaration_form_payee_attached')" class="link">Delete</a>
                  </div>

                  <div *ngIf="!valid && !cardsPosSignedDeclarationFormPayeeAttachedFileExists" class="red error">
                    Signed Declaration Form required
                  </div>
                </div>
              </div>

            </div>

              <div  id="save_checklist" *ngIf="loSubTags?.length == 0">
                <div class="col-md-3">
                  
                </div>
                <div class="col-md-6">
                </div>         
                <div class="col-md-3">
                  <button type="submit" class="btn btn-primary btn-block center" >Submit</button>
                </div>   

                
              </div>
            </form>
      </div>
    </div>
  </div>
</div>
</section>
</div>